/**
 * @description renders a sortable table header
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';

/**
 * @prop children {string | element | element[]} - column header content
 * @prop id {string} - the column id in the data object
 * @prop onSort {function} - callback function that handles setting the sort order/orderby state. it accepts the column id
 * @prop order {string | null} - the "asc" or "desc" order
 * @prop orderBy {string | null} - the currently sorted column id
 * @prop sx {{ cell: object, label: object }} - css styling for the cell and the label
 */
const SortableCell = ({
  children,
  id,
  onSort,
  order,
  orderBy,
  sx
}) => (
  <TableCell
    sortDirection={orderBy === id ? order : false}
    sx={sx?.cell}
  >
    <TableSortLabel
      active={orderBy === id}
      direction={orderBy === id ? order : 'asc'}
      onClick={() => onSort(id)}
      sx={sx?.label}
    >
      {children}
    </TableSortLabel>
  </TableCell>
);

SortableCell.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  id: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  sx: PropTypes.shape({ cell: PropTypes.object, label: PropTypes.object })
};

SortableCell.defaultProps = {
  order: null,
  orderBy: null,
  sx: null
};

export default SortableCell;
